// extracted by mini-css-extract-plugin
export default {"container":"EmptyOpeningList_container__t3ajT","content":"EmptyOpeningList_content__CsQKY"};